import { render } from "./TrueLayerConnect.vue?vue&type=template&id=da3ca22a&scoped=true"
import script from "./TrueLayerConnect.vue?vue&type=script&lang=js"
export * from "./TrueLayerConnect.vue?vue&type=script&lang=js"

import "./TrueLayerConnect.vue?vue&type=style&index=0&id=da3ca22a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3ca22a"]])

export default __exports__